import { Action } from '@ngrx/store';
import { CONFIG } from '../../config';

//state
export interface StaticState {
  logo: { [ key: string]: string};
  routes: any[];
  images: any[];
}

export const STATIC_STATE_INIT: StaticState = {
  logo: {
    'white': CONFIG.url_static + 'logo/logo-white.png'
  },
  routes: [
    { path: '/', label: 'Inicio', icon: 'star' },
    //{ path: '/dashboard', label: 'Dashboard', icon: 'star' },
    { path: '/commerce', label: 'Comercio', icon: 'star' },
    { path: '/sales', label: 'Ventas TPV', icon: 'star' },
    { path: '/casefile', label: 'Exp. Digital y Cotejo', icon: 'star' },
    { path: '/buro', label: 'Buro', icon: 'star' },
  ],
  images: []
}

//reducer
export function staticReducer(state: StaticState = STATIC_STATE_INIT, action: Action): StaticState {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/static/index.ts